import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBanner, removeBanner } from 'slice/bannerSlice';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const List = () => {
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.banner);

    useEffect(() => {
        dispatch(getBanner());
    }, [dispatch]);

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeBanner(id));
                Swal.fire('Deleted!', 'Banner has been deleted.', 'success');
                setTimeout(() => dispatch(getBanner()), 500);
            }
        });
    };

    const getImageUrl = (img) => {
        const backend = process.env.REACT_APP_BACKEND || "http://localhost:8001/";
        const base = backend.endsWith('/') ? backend : backend + '/';
        return `${base}uploads/${img.trim()}`;
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Banners List</h4>
                <Link to="/khajuraho/banners/add">
                    <button className="btn addbtn">Add Banner</button>
                </Link>
            </div>

            <div className="mx-4 mt-5 bg-white p-3 rounded shadow">
                <table className="table table-hover">
                    <thead className="thead-light">
                        <tr>
                            <th>Sr.No</th>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="4" className="text-center">Loading...</td></tr>
                        ) : data && data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <img src={getImageUrl(item.image)} alt="" width={100} height={60} style={{ objectFit: 'cover' }} className="rounded" />
                                    </td>
                                    <td>{item.title || 'N/A'}</td>
                                    <td>
                                        <div className="d-flex gap-2">
                                            <Link to={`/khajuraho/banners/update/${item.id}`}>
                                                <button className="btn btn-sm btn-info text-white mr-2">Edit</button>
                                            </Link>
                                            <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-danger">Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="4" className="text-center">No Banners Found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default List;
